<template>
  <div>
      <ModalBase :show-modal="showModal" @close-modal="close" :overlay-scrollb="true">
            <template v-slot:titlebar>
                <TitleBar variant-class="title-modal">
                    <template v-slot:title>
                        <span v-translate>Company cost categories</span>
                    </template>
                </TitleBar>
            </template>
            <template v-slot:maincontent>
                <CostTypesSettings @costTypeCreated="onCostTypeCreated" @costTypeUpdated="onCostTypeUpdated" />
            </template>
      </ModalBase>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import ModalBase from "@/components/base_components/ModalBase";
import CostTypesSettings from "@/views/settings/CostTypesSettings";

export default {
    name: "CostTypesModal",
    components: {TitleBar, ModalBase, CostTypesSettings},
    props: {
        showModalOn: {
            type: Array
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.showModal = this.showModalOn.includes(to.name);
                (this.showModal) ? document.body.classList.add('modal-on') : document.body.classList.remove('modal-on');
            }
        },
    },
    data() {
        return {
            showModal: false
        }
    },
    created() {
        window.addEventListener('keydown', this.closeEventListener);
    },
    destroyed () {
        window.removeEventListener('keydown', this.closeEventListener);
    },
    methods: {
        closeEventListener(event) {
            if (this.showModal && event.key === 'Escape') this.close();
        },
        close() {
            this.$router.push({name: 'BalanceSheet'});
        },
        onCostTypeCreated(val) {
            this.$emit("costTypeCreated", val);
        },
        onCostTypeUpdated(val) {
            this.$emit("costTypeUpdated", val);
        }
    }
}
</script>

<style scoped>

</style>